import { h } from 'preact';
import { isWebPSupported } from 'utils/isWebPSupported';

const mimeTypesMap = { jpg: 'jpeg', png: 'png' };
const getMimeType = (ext) => `image/${mimeTypesMap[ext] || ext}`;

export function getAssetUrl(src, fallbackFormat = 'jpg') {
	return isWebPSupported() ? src : src?.replace(/\.webp$/, `.${fallbackFormat}`);
}

export function Picture({ src, fallbackFormat, ...props }) {
	if (!src?.endsWith?.('.webp')) {
		return <img {...props} src={src} />;
	}
	let fallback = src.replace(/webp$/, fallbackFormat || 'jpg');
	return (
		<picture>
			<source srcset={src} type="image/webp" />
			<source srcset={fallback} type={getMimeType(fallbackFormat)} />
			<img {...props} src={fallback} />
		</picture>
	);
}

export function css(asset, fallbackFormat) {
	return asset ? `url(${getAssetUrl(asset, fallbackFormat)})` : '';
}